import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';

import { Box } from '@material-ui/core';

import axios from '../../lib/axios';
// import { validate } from 'isemail';
import { StepWizardChildProps } from '../StepWizard';
import Question from './components/Question';
import Step from './components/Step';
import TextField from './components/TextField';

interface Props extends Partial<StepWizardChildProps> {
  onUpdate?: (data: any) => void;
  onValidate?: (valid: boolean) => void;
}

const step = 3;

const validateZipcode = async (zipcode: string) => {
  try {
    const res = await axios.get(`/zipcode/${zipcode}`);

    return res.data.valid;
  } catch (err) {
    return err.response?.data?.message || 'Invalid zipcode';
  }
};

const StepAboutYourself = ({ onUpdate, onValidate }: Props) => {
  const { register, formState, getValues, errors } = useForm({
    mode: 'onChange',
  });

  useEffect(() => {
    if (typeof onValidate === 'function') {
      onValidate(formState.isValid);
    }

    if (typeof onUpdate === 'function') {
      onUpdate(getValues());
    }
  }, [formState.isValid]);

  return (
    <form>
      <Box>
        <Step num={step} />
        <Question label="Tell us more about yourself." />
        <Box display="flex" flexDirection="column" alignItems="center">
          <TextField
            inputRef={register({
              required: { value: true, message: 'Required' },
            })}
            required
            label="First Name"
            name="firstName"
            helperText={errors.firstName && errors.firstName.message}
            style={{ marginBottom: 16 }}
          />
          <TextField
            inputRef={register({
              required: { value: true, message: 'Required' },
            })}
            required
            label="Last Name"
            name="lastName"
            helperText={errors.lastName && errors.lastName.message}
            style={{ marginBottom: 16 }}
          />
          <TextField
            inputRef={register({
              required: { value: true, message: 'Required' },
              minLength: { value: 5, message: 'Invalid zipcode' },
              validate: async (zipcode) => await validateZipcode(zipcode),
            })}
            required
            label="Zipcode"
            name="zipcode"
            helperText={errors.zipcode && errors.zipcode.message}
            style={{ marginBottom: 16 }}
          />
          {/* <TextField
            inputRef={register({ required: true })}
            required
            label="Email Address"
            name="email"
            style={{ marginBottom: 16 }}
          /> */}
        </Box>
      </Box>
    </form>
  );
};

export default StepAboutYourself;
